import { combineReducers } from 'redux';
import auth from './auth';
import message from './message';
import counterReducer from './counter';

export default combineReducers({
  auth,
  message,
  counter: counterReducer,
});
